import React from 'react';
import { motion } from 'framer-motion';

const BackgroundAnimations: React.FC = () => {
  return (
    <div className="fixed inset-0 z-0 pointer-events-none overflow-hidden">
      {/* Subtle floating herb particles */}
      {[
        { x: '5%', delay: 0, duration: 18 },
        { x: '20%', delay: 3, duration: 22 },
        { x: '40%', delay: 7, duration: 16 },
        { x: '65%', delay: 1.5, duration: 20 },
        { x: '80%', delay: 5, duration: 24 },
        { x: '92%', delay: 9, duration: 17 },
      ].map((leaf, i) => (
        <motion.div
          key={i}
          className="absolute"
          style={{ left: leaf.x }}
          initial={{ y: '-5vh', opacity: 0 }}
          animate={{
            y: '110vh',
            opacity: [0, 0.18, 0.15, 0],
            rotate: [0, 15, -10, 20],
            x: [0, 20, -15, 10, 0],
          }}
          transition={{
            duration: leaf.duration,
            repeat: Infinity,
            delay: leaf.delay,
            ease: 'easeInOut',
          }}
        >
          <svg width="10" height="17" viewBox="0 0 10 17" fill="none">
            <path d="M5 1C8 3 9 8 5 16C1 8 2 3 5 1Z" fill="#4A7C59" />
          </svg>
        </motion.div>
      ))}

      {/* Soft ambient orbs */}
      <motion.div
        className="absolute top-[10%] right-[8%] w-64 h-64 rounded-full bg-herb-green/5"
        animate={{ scale: [1, 1.08, 1], opacity: [0.4, 0.7, 0.4] }}
        transition={{ duration: 12, repeat: Infinity, ease: 'easeInOut' }}
      />
      <motion.div
        className="absolute bottom-[15%] left-[5%] w-48 h-48 rounded-full bg-amber-herb/4"
        animate={{ scale: [1, 1.1, 1], opacity: [0.3, 0.5, 0.3] }}
        transition={{ duration: 15, repeat: Infinity, ease: 'easeInOut', delay: 3 }}
      />
      <motion.div
        className="absolute top-[50%] left-[50%] w-32 h-32 rounded-full bg-herb-light/5"
        animate={{ scale: [1, 1.15, 1] }}
        transition={{ duration: 18, repeat: Infinity, ease: 'easeInOut', delay: 6 }}
      />
    </div>
  );
};

export default BackgroundAnimations;
